import API from '@/assets/libraries/API_Requests';
import { useShowOperatorStore } from '@/stores/showOperatorStore';
import { cloneDeep } from 'lodash';

export async function getControllers() {
	try {
		const response = await API.Call('GET', API.DESKTOP_AGENT + `/controllers`);
		if (response.error != undefined) {
			console.error(response);
			throw new Error(response.error);
		}

		return response;
	} catch (error) {
		console.error(JSON.stringify(error));
	}
}

export async function getAllModulesDetails({ controller_mac_address, filters, search, search_type }) {
	const show_operator_store = useShowOperatorStore();

	try {
		let search_params = new URLSearchParams();
		if (controller_mac_address != undefined) {
			search_params.append('controller_mac_address', controller_mac_address);
		}

		if (filters != undefined) {
			search_params.append('filters', JSON.stringify(filters));
		}

		if (search != undefined) {
			search_params.append('search', search);
		}

		if (search_type != undefined) {
			search_params.append('search_type', search_type);
		}

		show_operator_store.is_loading_all_modules = true;
		const response = await API.Call('GET', API.DESKTOP_AGENT + `/modules/details?${search_params.toString()}`);
		show_operator_store.is_loading_all_modules = false;
		if (response.error != undefined) {
			console.error(response);
			throw new Error(response.error);
		}

		return response;
	} catch (error) {
		show_operator_store.is_loading_all_modules = false;
		throw new Error(JSON.stringify(error));
	}
}

export async function getAllModules() {
	try {
		const response = await API.Call('GET', API.DESKTOP_AGENT + `/modules`);
		if (response.error != undefined) {
			console.error(response);
			throw new Error(response.error);
		}

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function getOneModule(module_id, controller_mac_address) {
	try {
		const response = await API.Call('GET', API.DESKTOP_AGENT + `/modules/${module_id}/controllers/${controller_mac_address}`);
		if (response.error != undefined) {
			console.error(response);
			throw new Error(response.error);
		}

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function getModuleActivity(module_id, controller_mac_address) {
	try {
		const response = await API.Call('GET', API.DESKTOP_AGENT + `/modules/${module_id}/controllers/${controller_mac_address}/activity`);
		console.log('response of this is here', response);
		if (response.error != undefined) {
			console.error(response);
			throw new Error(response.error);
		}

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

let pending_module_data_requests = {};

export async function getOneModuleDetail({ module_id, controller_mac_address, filters = undefined, search = undefined, search_type = undefined }) {
	if (pending_module_data_requests[module_id] != undefined) {
		throw new Error('REQUEST_FOR_MODULE_ID_IS_ALREADY_BEING_PROCESSED');
	}

	let search_params = new URLSearchParams();

	if (filters != undefined) {
		search_params.append('filters', JSON.stringify(filters));
	}

	if (search != undefined) {
		search_params.append('search', search);
	}

	if (search_type != undefined) {
		search_params.append('search_type', search_type);
	}

	try {
		pending_module_data_requests[module_id] = true;
		const response = await API.Call('GET', API.DESKTOP_AGENT + `/modules/${module_id}/controllers/${controller_mac_address}/details?${search_params.toString()}`);
		delete pending_module_data_requests[module_id];

		if (response.error != undefined) {
			console.error(response);
			throw new Error(response.error);
		}

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function getScriptDetails(script_id, controller_mac_address) {
	try {
		const response = await API.Call('GET', `${API.DESKTOP_AGENT}/scripts/${script_id}/controllers/${controller_mac_address}`);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function getAllScripts({ controller_mac_address }) {
	try {
		const response = await API.Call('GET', API.DESKTOP_AGENT + `/scripts?controller_mac_address=${controller_mac_address}`);
		if (response.error != undefined) {
			console.error(response);
			throw new Error(response.error);
		}

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function createNewSession({ name = undefined } = {}) {
	try {
		if (name != undefined && typeof name == 'string' && name.trim() == '') {
			name = undefined;
		}

		const body = {
			name,
		};
		const response = await API.Call('POST', `${API.DESKTOP_AGENT}/sessions`, body);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function getCurrentSession() {
	try {
		const response = await API.Call('GET', `${API.DESKTOP_AGENT}/sessions/current`);
		return response;
	} catch (error) {
		console.error(error);
	}
}

export async function requestControllerToForceRefresh() {
	try {
		const body = {};
		const response = await API.Call('PUT', `${API.DESKTOP_AGENT}/controllers/modules/refresh`, body);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function getApplicationDetails() {
	try {
		const response = await API.Call('GET', `${API.DESKTOP_AGENT}/application`);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function ignoreOrUnignoreModuleCueContinuity({ controller_mac_address, module_id, cue_index, is_ignored }) {
	try {
		const body = { cue_index, is_ignored };
		const response = await API.Call('PUT', `${API.DESKTOP_AGENT}/modules/${module_id}/controllers/${controller_mac_address}/continuity/ignore`, body);
		return response;
	} catch (error) {
		throw new Error(error);
	}
}

export async function getEventsList({ controller_mac_address, script_id, search, search_type, filters }) {
	try {
		let search_params = new URLSearchParams();

		if (filters != undefined) {
			search_params.append('filters', JSON.stringify(filters));
		}

		if (search != undefined) {
			search_params.append('search', search);
		}

		if (search_type != undefined) {
			search_params.append('search_type', search_type);
		}
		const response = await API.Call('GET', `${API.DESKTOP_AGENT}/scripts/${script_id}/controllers/${controller_mac_address}/events?${search_params.toString()}`);
		return response;
	} catch (error) {
		console.error(error);
	}
}

export async function getSessions() {
	try {
		const response = await API.Call('GET', `${API.DESKTOP_AGENT}/sessions`);
		return response;
	} catch (error) {
		console.error(error);
	}
}

export async function stopScript(controller_mac_address) {
	try {
		return await API.Call('PUT', `${API.DESKTOP_AGENT}/controllers/${controller_mac_address}/actions/scripts/playback/stop`);
	} catch (error) {
		console.error(error);
	}
}

export async function pauseScript(controller_mac_address) {
	try {
		return await API.Call('PUT', `${API.DESKTOP_AGENT}/controllers/${controller_mac_address}/actions/scripts/playback/pause`);
	} catch (error) {
		console.error(error);
	}
}

export async function playScript({ controller_mac_address, script_id, start_at_row_index = undefined } = {}) {
	try {
		let body = {
			script_id: script_id,
			start_at_row_index: start_at_row_index,
		};

		return await API.Call('PUT', `${API.DESKTOP_AGENT}/controllers/${controller_mac_address}/actions/scripts/playback/start`, body);
	} catch (error) {
		console.error(error);
	}
}

export async function resumeScript(controller_mac_address) {
	try {
		return await API.Call('PUT', `${API.DESKTOP_AGENT}/controllers/${controller_mac_address}/actions/scripts/playback/resume`);
	} catch (error) {
		console.error(error);
	}
}

export async function fireStep(controller_mac_address) {
	try {
		return await API.Call('PUT', `${API.DESKTOP_AGENT}/controllers/${controller_mac_address}/actions/fire/step`);
	} catch (error) {
		console.error(error);
	}
}

export async function fireAlternate({ controller_mac_address, alternate_type }) {
	try {
		return await API.Call('PUT', `${API.DESKTOP_AGENT}/controllers/${controller_mac_address}/actions/fire/alternate`, { alternate_type });
	} catch (error) {
		console.error(error);
	}
}

export async function getAllTimers() {
	try {
		return await API.Call('GET', `${API.DESKTOP_AGENT}/timers`);
	} catch (error) {
		console.error(error);
	}
}

export async function createTimer({ type, name = undefined }) {
	try {
		const timer = {
			name,
			type,
		};

		return await API.Call('POST', `${API.DESKTOP_AGENT}/timers`, timer);
	} catch (error) {
		console.error(error);
	}
}

export async function startTimer(timer_id) {
	try {
		return await API.Call('PUT', `${API.DESKTOP_AGENT}/timers/${timer_id}/start`);
	} catch (error) {
		console.error(error);
	}
}

//TODO: how about we pass in the time when the timer was actually paused in the UI to avoid clock drift?
export async function pauseTimer(timer_id) {
	try {
		return await API.Call('PUT', `${API.DESKTOP_AGENT}/timers/${timer_id}/pause`);
	} catch (error) {
		console.error(error);
	}
}

export async function resetTimer(timer_id) {
	try {
		return await API.Call('PUT', `${API.DESKTOP_AGENT}/timers/${timer_id}/reset`);
	} catch (error) {
		console.error(error);
	}
}

export async function updateTimer(timer_id, timer_properties) {
	try {
		// Ensure the toggle switch boolean properties are encoded as either 'true' or 'false' in string format
		const timer_properties_clone = cloneDeep(timer_properties);
		const properties_to_transform = ['allow_overrun', 'start_timer_with_script', 'pause_timer_with_script', 'reset_timer_upon_script_initial_start'];
		for (const key of properties_to_transform) {
			if (key in timer_properties_clone) {
				timer_properties_clone[key] = String(!!timer_properties_clone[key]);
			}
		}
		return await API.Call('PUT', `${API.DESKTOP_AGENT}/timers/${timer_id}`, timer_properties_clone);
	} catch (error) {
		console.error(error);
	}
}

export async function deleteTimer(timer_id) {
	try {
		return await API.Call('DELETE', `${API.DESKTOP_AGENT}/timers/${timer_id}`);
	} catch (error) {
		console.error(error);
	}
}

export async function jumpToEvent(controller_mac_address, row_index, script_id) {
	try {
		return await API.Call('PUT', `${API.DESKTOP_AGENT}/controllers/${controller_mac_address}/actions/scripts/playback/jump_to_event`, { script_id, row_index });
	} catch (error) {
		console.error(error);
	}
}
